import { render, staticRenderFns } from "./productBalanceDetail.vue?vue&type=template&id=178efefb&scoped=true&"
import script from "./productBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./productBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./productBalanceDetail.vue?vue&type=style&index=0&id=178efefb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178efefb",
  null
  
)

export default component.exports